import type { PressurePoint } from "@/types/geodata";

function project(lat: number, lng: number) {
  return {
    left: `${((lng + 180) / 360) * 100}%`,
    top: `${((90 - lat) / 180) * 100}%`,
  };
}

export function HeatmapLayer({ points }: { points: PressurePoint[] }) {
  return (
    <div className="absolute inset-0 overflow-hidden">
      {points.map((point) => {
        const position = project(point.coordinates.lat, point.coordinates.lng);
        const size = 120 + point.pressureIndex * 2;
        return (
          <div
            key={point.id}
            className="absolute -translate-x-1/2 -translate-y-1/2 rounded-full blur-2xl"
            style={{
              ...position,
              width: size,
              height: size,
              background: `rgba(236, ${180 - point.pressureIndex}, 64, ${0.2 + point.pressureIndex / 260})`,
            }}
          />
        );
      })}
    </div>
  );
}
